<template>
  <div class="ProductionPlan">
    <div class="page-title">{{ title }}</div>
    <div class="flex">
      <div class="lt-area flex-auto">
        <el-input
          class="input-with-select"
          size="mini"
          v-model="searchWord"
          :placeholder="placeholder"
          @keydown.enter.native="handleClickFilter"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleClickFilter"
          />
        </el-input>
        <div class="right-search-head inline" style="margin-left: 10px">
          <div class="inline">
            <APeriodSelector
              ref="period"
              value="0d"
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >{{ $t("button.search") }} (F5)</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row-splitter">
      <ATable
        ref="table"
        v-loading="loading_contract"
        :data="filterItemsContract"
        max-height="322px"
        hide-button-insert
        hide-pagination
        border
        @row-click="handleRowClickContract"
        @selection-change="handleContractSelectionChange"
      >
        <div slot="search">
          <div class="page-subtitle">{{ $t("lang.list_title_plan") }}</div>
        </div>
        <el-table-column
          type="selection"
          align="center"
          :width="$width.selection"
          :selectable="selectableContract"
        />
        <el-table-column
          type="index"
          label="No"
          :width="$width.index"
          :index="handleIndex"
        />
        <el-table-column
          prop="contract_date"
          :label="$t('lang.contract_date')"
          :width="$width.date"
          :formatter="util.dateFormat"
        ></el-table-column>
        <el-table-column
          prop="code"
          :label="$t('lang.contract_code')"
          width="90"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목"
          width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="amount"
          width="60"
          class-name="cell-number"
          :label="$t('lang.contract_amount')"
        />
        <el-table-column
          prop="delivery_date"
          :label="$t('lang.delivery_date')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="specification"
          :label="$t('lang.specification')"
          show-overflow-tooltip
        />
        <el-table-column prop="desc" label="비고" show-overflow-tooltip />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <div class="inline" style="margin-right: 10px">
            <el-button
              type="primary"
              :disabled="contractSelection.length < 1 || !has_grant_write"
              @click="handleClickMultiProduction"
              >생산 지시</el-button
            >
          </div>
        </div>
      </ATable>
    </div>

    <div class="row-splitter">
      <ATable
        ref="table2"
        v-loading="loading_production"
        buttons-width="240px"
        max-height="338px"
        :data="filterItemsProduction"
        hide-button-insert
        hide-pagination
        border
        @row-click="handleProductionRowClick"
        @selection-change="handleProductionSelectionChange"
      >
        <div slot="search">
          <div class="page-subtitle">
            {{ $t("lang.list_title_production_plan") }}
          </div>
        </div>
        <el-table-column
          type="selection"
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          align="center"
          :index="handleIndex2"
        />
        <el-table-column
          prop="plan_date"
          :label="$t('lang.production_plan_date')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="delivery_date"
          :label="$t('lang.delivery_date')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column prop="contract_code" label="수주번호" width="90" />
        <el-table-column prop="code" label="생산번호" width="90" />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="plan_amount"
          label="계획량"
          class-name="cell-number"
          width="60"
        />
        <el-table-column
          prop="amount"
          label="생산량"
          class-name="cell-number"
          width="60"
        />
        <el-table-column
          prop="specification"
          :label="$t('lang.specification')"
          show-overflow-tooltip
        />
        <el-table-column prop="desc" label="비고" show-overflow-tooltip />
        <!-- <el-table-column :label="$t('lang.project_number')" width="80">
          <template slot-scope="scope">{{ resolveProcess(scope.row.process_id) }}</template>
        </el-table-column> -->
        <el-table-column
          prop="status_flag"
          label="상태"
          :width="80"
          :formatter="resolveProductionStatus"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <div class="inline" style="margin-right: 10px">
            <el-button
              type="primary"
              :disabled="!has_grant_write"
              @click="handleClickAddProduction"
              >생산 계획 등록</el-button
            >
          </div>
          <div class="inline">
            <el-button
              type="danger"
              :disabled="productionSelection.length < 1 || !has_grant_write"
              @click="handelClickDelProduction"
              >생산 지시 취소</el-button
            >
          </div>
        </div>
      </ATable>
    </div>

    <el-dialog
      title="생산 지시"
      top="0"
      custom-class="form-dialog"
      destroyOnClose
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <ProductionForm
        ref="form"
        v-if="dialogVisible"
        :target="selectedData"
        :source="selectedSource"
        :has_grant_write="has_grant_write"
        @completed="handleCompleted"
      />
    </el-dialog>

    <el-dialog
      title="생산 지시"
      top="0"
      custom-class="form-dialog"
      destroyOnClose
      :visible.sync="multiDialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened('multi_form')"
    >
      <ProductionMultiForm
        ref="multi_form"
        v-if="multiDialogVisible"
        :selection="contractSelection"
        :load_button="load_button"
        @completed="handleCompletedMultiForm"
      />
    </el-dialog>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { production_process } from "@/common/mixins/production_process";
import ProductionForm from "./ProductionForm";
import ProductionMultiForm from "./ProductionMultiForm";

export default {
  name: "ProductionPlan",
  mixins: [form_container, authority_level, production_process],
  components: { ProductionForm, ProductionMultiForm },
  data() {
    return {
      title: this.$t("title.production_plan"),
      dialogVisible: false,
      placeholder: "수주번호, 거래처, 품목",
      search_field: ["code", "customer_name", "product_name", "contract_code"],
      search_fieldSale: ["contract_code", "delivery_date", "product_name"],
      searchWord: null,
      fixedSearchWord: "",
      loading_contract: false,
      items_contract: [],
      contractSelection: [],
      loading_production: false,
      items_production: [],
      productionSelection: [],
      selectedSource: undefined,
      selectedData: undefined,
      multiDialogVisible: false,
      load_button: false,
    };
  },
  computed: {
    filterItemsContract() {
      return this.util.filterMultiFields(
        this.items_contract,
        this.search_field,
        this.fixedSearchWord
      );
    },
    filterItemsProduction() {
      return this.util.filterMultiFields(
        this.items_production,
        this.search_field,
        this.fixedSearchWord
      );
    },
    has_grant_write() {
      return this.isWriteLevel("production_plan");
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    loadData() {
      this.loading_contract = true;
      this.api.listProductionContractPeriod(this.period).then((res) => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_contract = res.data.filter((d) => d.amount >= 0);
        this.items_contract.forEach((item) => {
          item.specification = this.resolveSpecifications(item);
        });
      });
      this.loading_production = true;
      this.api.listProduction(this.period).then((res) => {
        this.loading_production = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_production = res.data;
      });
    },
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      this.selectedSource = null;
      this.selectedData = clone;
      this.dialogVisible = true;
    },
    doDelete() {
      let params = [];
      this.productionSelection.forEach((item) => {
        if (item.id !== 0) params.push(item.id);
      });
      this.processProduction(
        "생산 취소 중입니다.",
        () => this.api.deleteProduction(params),
        // 생산은 건별로 처리되므로 오류가 나도 앞 건은 반영되어 있다.
        { always: () => this.loadData() }
      );
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleRowClickContract(data) {
      this.selectedSource = Object.assign({}, data);
      this.selectedData = null;
      this.dialogVisible = true;
    },
    handleProductionRowClick(select) {
      this.openDialog(select);
    },
    handleClickFilter() {
      this.fixedSearchWord = this.searchWord;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleIndex2(index) {
      return this.$refs.table2.indexResolver(index);
    },
    // handleClickSaveSale() {
    //   if (this.contractSelection.length < 1) {
    //     this.util.notify(
    //       this,
    //       "w",
    //       this.$t("lang.production"),
    //       this.$t("message.no_selection")
    //     );
    //     return;
    //   }
    //   let params = [];
    //   this.contractSelection.forEach(item => {
    //     params.push({
    //       id: item.id,
    //       specification: this.resolveSpecifications(item)
    //     });
    //   });
    //   this.api.registerProduction(params).then(res => {
    //     if (res.error !== this.system.noError) {
    //       this.util.notify_response_error(this, this.title, res);
    //       return;
    //     }
    //     this.loadData();
    //   });
    // },
    handleProductionSelectionChange(selection) {
      // 생산 계획 선택 처리
      this.productionSelection = selection;
    },
    handleClickAddProduction() {
      this.openDialog();
    },
    handelClickDelProduction() {
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleCompleted(reload) {
      this.dialogVisible = false;
      if (!reload) {
        return;
      }
      this.loadData();
    },
    resolveStatus(item) {
      if (item) {
        let fix_amount = item.fix_amount ? item.fix_amount : 0;
        let amount = item.amount;

        if (fix_amount === 0) {
          return "견적";
        } else if (fix_amount < amount) {
          return "진행";
        } else if (fix_amount === amount) {
          return "매출";
        } else {
          return "매출 초과";
        }
      }

      return null;
    },
    resolveStatusSale(item) {
      if (item) {
        let fix_amount = item.fix_amount ? item.fix_amount : 0;
        let amount = item.amount;

        if (fix_amount === 0) {
          return "매출";
        } else if (fix_amount < amount) {
          return "진행";
        } else if (fix_amount === amount) {
          return "견적";
        } else {
          return "매출 초과";
        }
      }
      return null;
    },
    resolveProductionStatus(data, column, val) {
      switch (val) {
        case "1":
          return "시작";
        case "2":
          return "완료";
        default:
          return "계획";
      }
    },
    resolveSpecifications(row) {
      if (row.specifications.length < 1) {
        return "";
      }
      let ret = "";
      row.specifications.forEach((s) => {
        if (ret !== "") {
          ret += ", ";
        }
        ret += s.product_name + ": " + s.per_amount + s.unit_name;
      });
      return ret;
    },
    handleContractSelectionChange(selection) {
      this.contractSelection = selection;
    },
    handleClickMultiProduction() {
      this.multiDialogVisible = true;
    },
    handleCompletedMultiForm(result) {
      this.multiDialogVisible = false;
      this.load_button = false;
      if (!result) {
        return;
      }
      this.util.notify_success(this, this.title, "등록되었습니다.");
      this.loadData();
    },
    selectableContract(row) {
      return row.amount > 0;
    },
  },
};
</script>
